export type InputProps = React.ComponentPropsWithRef<"input">;

export function Input({ className = "", ref, ...props }: InputProps) {
  return (
    <input
      ref={ref}
      className={`w-full bg-page border border-border-subtle rounded-md px-3 py-2 text-sm text-white placeholder:text-text-faint focus:outline-none focus:border-brand focus:ring-1 focus:ring-brand disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    />
  );
}
